module.exports = __webpack_public_path__ + "img/payBannerOrange.28bd0163.jpg";